import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
var IGLUniformData = /*#__PURE__*/_createClass(function IGLUniformData() {
  _classCallCheck(this, IGLUniformData);
});
var GLProgram = /*#__PURE__*/function () {
  function GLProgram(program, uniformData) {
    _classCallCheck(this, GLProgram);
    this.program = program;
    this.uniformData = uniformData;
    this.uniformGroups = {};
    this.uniformDirtyGroups = {};
    this.uniformBufferBindings = {};
  }
  _createClass(GLProgram, [{
    key: "destroy",
    value: function destroy() {
      this.uniformData = null;
      this.uniformGroups = null;
      this.uniformDirtyGroups = null;
      this.uniformBufferBindings = null;
      this.program = null;
    }
  }]);
  return GLProgram;
}();
export { GLProgram, IGLUniformData };